module.exports = __webpack_public_path__ + "img/ie.0dcb213a.svg";